import { CLEAR_COMMENTS, UPDATE_COMMENTS, ADD_COMMENT, UPDATE_COMMENT, MASK_COMMENT } from "../reducers/actiontypes";
import { addError, addErrors, clearErrors, startLoading, finishLoading, updateCreateForm, updateCommentField, cancelComment, clearCreateForm } from "./ui";
import { parseTimestamp, formatDateAsRFC3339, logEvent } from "../util";

export let clearComments = function() {
	return {
		type: CLEAR_COMMENTS
	};
}

export let updateComments = function(comments) {
	return {
		type: UPDATE_COMMENTS,
		comments: comments
	};
}

export let fetchComments = function() {
	return function(dispatch, getState) {
		var instance = getState().instances.current;

		dispatch(clearComments());
		dispatch(clearErrors());
		dispatch(startLoading());

		window.getComments(instance, function(err, data){
			if (err) {
				dispatch(addError("There was an error loading the comments."));
				dispatch(finishLoading());
				return;
			}

			dispatch(updateComments(data));
			dispatch(finishLoading());
		});
	};
};

export let updateComment = function(index, comment) {
	return {
		type: UPDATE_COMMENT,
		comment: comment,
		index: index
	}
};

export let addComment = function(comment, parent_index) {
	return {
		type: ADD_COMMENT,
		comment: comment,
		parent_index: parent_index
	}
};

export let saveNewComment = function(comment_type) {
	return function(dispatch, getState) {
		var state = getState(),
			duration = state.player.duration,
			user = state.user.id,
			instance = state.instances.current,
			create_form = state.ui.create_form,
			comment = {
				body: create_form.body,
				timestamp: 0,
				comment_type: comment_type,
				creator: user,
				instance: instance
			},
			messages = [];

		// body validation
		if (comment.body.length === 0) {
			messages.push("You have not entered a comment");
		}

		// timestamp validation
		if (create_form.bTimelineComment){
			try {
				comment.timestamp = parseTimestamp(create_form.timestamp, duration);
			}
			catch (err) {
				messages.push(err.toString());
			}
		}

		if (messages.length) {
			dispatch(updateCreateForm("message", messages));
			dispatch(updateCreateForm("message_colour", "danger"));
			return;
		}

		window.onCreateComment(comment, function(err, comment) {
			if (err) {
				dispatch(updateCreateForm("message", err.map(function(e){
					if (e.message === "Invalid value") {
						return `${e.message} in ${e.details.not_allowed}: ${e.details.expected}`;
					}

					return e.message;
				})));
				dispatch(updateCreateForm("message_colour", "danger"));
				return;
			}

			dispatch(addComment(comment));
			dispatch(clearCreateForm());

			logEvent({
				event: 'comment',
				comment_id: comment.objectid,
				comment_type: comment.comment_type,
				change: 'add',
				user: state.user.id,
				comment_timestamp: comment.timestamp,
				comment_segment: Math.floor(comment.timestamp / duration * 100 / 2.5) * 2.5,
				comment_status: "live",
				comment_reply: false,
				comment_created: formatDateAsRFC3339(new Date())
			});
		});
	}
}

export let saveComment = function() {
	return function(dispatch, getState) {
		var state = getState(),
			duration = state.player.duration,
			user = state.user.id,
			instance = state.instances.current,
			submitted = state.ui.dialog,
			comment = {
				body: submitted.body,
				timestamp: 0,
				comment_type: submitted.comment_type,
				creator: user,
				instance: instance
			},
			messages = [];

		// body validation
		if (comment.body.length === 0) {
			messages.push("You have not entered a comment");
		}

		// timestamp validation
		if (state.ui.dialog.bTimelineComment){
			try {
				comment.timestamp = parseTimestamp(submitted.timestamp, duration);
			}
			catch (err) {
				messages.push(err.toString());
			}
		}

		if (messages.length) {
			dispatch(updateCommentField("message", messages));
			dispatch(updateCommentField("message_colour", "danger"));
			return;
		}

		if (submitted.reply_to_index !== undefined) {
			comment.reply_to_id = state.comments[submitted.reply_to_index].objectid;
			comment.parent_id = state.comments[submitted.parent_index].objectid;
		}
		else if (submitted.index) {
			comment.reply_to_id = state.comments[submitted.index].reply_to_id;
			comment.parent_id = state.comments[submitted.index].parent_id;
		}

		if (submitted.index > -1) {
			comment.objectid = state.comments[submitted.index].objectid;

			window.onUpdateComment(comment, function(err, comment) {
				if (err) {
					dispatch(updateCommentField("message", err.map(function(e){
						if (e.message === "Invalid value") {
							return `${e.message} in ${e.details.not_allowed}: ${e.details.expected}`;
						}
	
						return e.message;
					})));
					dispatch(updateCommentField("message_colour", "danger"));
					return;
				}

				dispatch(updateComment(submitted.index, comment));
				dispatch(cancelComment());
			});
		}
		else {
			window.onCreateComment(comment, function(err, comment) {
				if (err) {
					dispatch(updateCommentField("message", err.map(function(e){
						if (e.message === "Invalid value") {
							return `${e.message} in ${e.details.not_allowed}: ${e.details.expected}`;
						}
	
						return e.message;
					})));
					dispatch(updateCommentField("message_colour", "danger"));
					return;
				}

				dispatch(addComment(comment, submitted.parent_index));
				dispatch(cancelComment());

				logEvent({
					event: 'comment',
					comment_id: comment.objectid,
					comment_type: comment.comment_type,
					change: 'add',
					user: user,
					comment_timestamp: comment.timestamp,
					comment_segment: Math.floor(comment.timestamp / duration * 100 / 2.5) * 2.5,
					comment_status: "live",
					comment_reply: comment.parent_id ? true : false,
					comment_created: formatDateAsRFC3339(new Date())
				});
			});
		}
	}
}

export let maskComment = function(objectid) {
	return {
		type: MASK_COMMENT,
		objectid: objectid
	};
}

export let removeComment = function(objectid) {
	return function(dispatch, getState) {
		var comment = getState().comments.filter(({objectid:thisid})=>thisid===objectid).pop();

		dispatch(clearErrors());

		window.onDeleteComment(comment, function(err) {
			if (err) {
				dispatch(addErrors(err.map(function(e){ return e.message; })));
				return;
			}

			dispatch(maskComment(objectid));
		});
	}
}